module.exports = __webpack_public_path__ + "assets/img/youtube.bafecf06.svg";